
import { useEffect, useState } from 'react';

import {
  client,
  getRevenuePivotBySalesRepCsvApiV1PivotTablesRevenueBySalesRepCsvGet,
  getProfitPivotBySalesRepCsvApiV1PivotTablesProfitBySalesRepCsvGet,
} from '../../client';
import PageLayout from '../../components/PageLayout/PageLayout';
import { useAuth } from '../../services/auth/AuthContext';
import notificationService from '../../services/notification/NotificationService';

const LandingPage = () => {
  const { getToken, isAuthenticated } = useAuth();
  const [isRevenueLoading, setIsRevenueLoading] = useState(false);
  const [isProfitLoading, setIsProfitLoading] = useState(false);

  useEffect(() => {
    const initializeClient = async () => {
      const token = await getToken();
      if (token) {
        client.setConfig({
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
      }
    };
    if (isAuthenticated) {
      initializeClient();
    }
  }, [getToken, isAuthenticated]);

  const handleDownloadRevenuePivotTable = async () => {
    setIsRevenueLoading(true);
    try {
      const response = await getRevenuePivotBySalesRepCsvApiV1PivotTablesRevenueBySalesRepCsvGet();

      // Create a blob from the response data
      const blob = new Blob([response.data as string], { type: 'text/csv' });

      // Create a URL for the blob
      const url = window.URL.createObjectURL(blob);

      // Create a temporary link element
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'revenue_pivot_table.csv');

      // Append the link to the body
      document.body.appendChild(link);

      // Trigger the download
      link.click();

      // Clean up
      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);

      // Show success notification
      notificationService.success('Revenue pivot table downloaded successfully');
      setIsRevenueLoading(false);
    } catch (error) {
      notificationService.error('Failed to download revenue pivot table. Please try again later.');
      setIsRevenueLoading(false);
    }
  };

  const handleDownloadProfitPivotTable = async () => {
    setIsProfitLoading(true);
    try {
      const response = await getProfitPivotBySalesRepCsvApiV1PivotTablesProfitBySalesRepCsvGet();

      // Create a blob from the response data
      const blob = new Blob([response.data as string], { type: 'text/csv' });

      // Create a URL for the blob
      const url = window.URL.createObjectURL(blob);

      // Create a temporary link element
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'profit_pivot_table.csv');

      // Append the link to the body
      document.body.appendChild(link);

      // Trigger the download
      link.click();

      // Clean up
      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);

      // Show success notification
      notificationService.success('Profit pivot table downloaded successfully');
      setIsProfitLoading(false);
    } catch (error) {
      notificationService.error('Failed to download profit pivot table. Please try again later.');
      setIsProfitLoading(false);
    }
  };

  return (
    <PageLayout pageId={'home'}>
      <div>
        <h1>Welcome to the CJ Brothers Analytics Portal</h1>
        <button
          onClick={handleDownloadRevenuePivotTable}
          style={{
            backgroundColor: '#4CAF50',
            border: 'none',
            color: 'white',
            padding: '10px 20px',
            textAlign: 'center',
            textDecoration: 'none',
            display: 'inline-block',
            fontSize: '16px',
            margin: '20px 10px 20px 0',
            cursor: 'pointer',
            borderRadius: '4px',
          }}
        >
          {isRevenueLoading ? 'Loading...' : 'Download Detailed Revenue Pivot Table'}
        </button>
        <button
          onClick={handleDownloadProfitPivotTable}
          style={{
            backgroundColor: '#4CAF50',
            border: 'none',
            color: 'white',
            padding: '10px 20px',
            textAlign: 'center',
            textDecoration: 'none',
            display: 'inline-block',
            fontSize: '16px',
            margin: '20px 0',
            cursor: 'pointer',
            borderRadius: '4px',
          }}
        >
          {isProfitLoading ? 'Loading...' : 'Download Detailed Profit Pivot Table'}
        </button>
      </div>
    </PageLayout>
  );
};

export default LandingPage;
